import * as React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

export function UploadingLoader({ fullScreen = true }) {
  return (
    <>
      {fullScreen ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100vw",
            height: "100vh",
            alignItems: "center",
            justifyContent: "center",
            position: "fixed",
            top: 0,
            left: "100px",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 9999,
          }}
        >
          <CircularProgress color="primary" size={40} />
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            backgroundColor: "#f5f5f5",
            borderRadius: 2,
            padding: 2,
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.15)",
          }}
        >
          <CircularProgress color="primary" size={30} />
        </Box>
      )}
    </>
  );
}
